import { Outlet } from "react-router-dom";

const MainPattyCash = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainPattyCash;